module.exports = __webpack_public_path__ + "56a8fd59012e78b66abce2fe20b4d075.png";